import React from 'react';
import clsx from 'clsx';
import { is } from '../../services/classify';
import { StickerMarkup, StickerVariant } from './StickerEnum';
import { getAlertClassName, getColorClassName } from '../../objects';
import { hashClass, isInEnum } from '../../helpers';
import { useTrilogyContext } from '../../context';
/**
 * Sticker component
 * @param children {ReactNode} Sticker child
 * @param variant {AlertState} Sticker variant : primary only
 * @param small {boolean} Small Sticker
 * @param flag {boolean} Flag sticker
 * @param outlined {boolean} Outlined sticker
 * @param hat {boolean} Hat Sticker ( for box )
 * - -------------------------- WEB PROPERTIES -------------------------------
 * @param markup {StickerMarkup} HTML element : p|span|div
 * @param className {string} Additionnal css classes
 * @param others
 */
const Sticker = ({ className, children, 
/* deprecated*/
stretched, 
/* deprecated*/
variant, small, 
/* deprecated*/
alert, hat, markup, 
/* deprecated*/
inverted, flag, outlined, ...others }) => {
    const { styled } = useTrilogyContext();
    const isValidVariant = isInEnum(StickerVariant, variant);
    const classes = hashClass(styled, clsx('sticker', stretched && is('stretched'), variant && !alert && isValidVariant && is(getColorClassName(variant)), alert && !variant && is(getAlertClassName(alert)), small && is('small'), hat && is('hat'), inverted && is('inverted'), flag && is('flag'), outlined && is('outlined'), className));
    const isCorrectMarkup = (stringMarkup) => {
        if (stringMarkup in StickerMarkup || Object.values(StickerMarkup).includes(stringMarkup))
            return true;
    };
    const Tag = markup && isCorrectMarkup(markup) ? markup : 'div';
    return (React.createElement(Tag, { className: classes, ...others }, children));
};
export default Sticker;
//# sourceMappingURL=Sticker.js.map